import React from 'react';
import { useSubscription } from '../../context/SubscriptionContext';
import StatusCards from './StatusCards';
import PlanLimitsPanel from '../plans/PlanLimitsPanel';
import { tokenResetLabel, isFreeLikePlan, displayPlanName } from '../../utils/planCatalogUtils';

const DashboardOverview = () => {
  const { subscription, getUsagePercentage, getRemainingRequests } = useSubscription();
  const usagePct = Math.min(100, Math.max(0, getUsagePercentage() || 0));
  const planLabel = displayPlanName(subscription?.plan_name, 'No active plan');
  const statusLabel = (subscription?.status || 'unknown').toString();
  const freeLike = isFreeLikePlan(
    subscription?.plan_name,
    subscription?.plan_type,
    subscription?.is_free_trial
  );
  const allocationLabel = (() => {
    if (subscription?.daily_token_limit != null || subscription?.daily_prompt_limit != null) {
      return 'monthly pool (daily caps also apply)';
    }
    if (subscription?.monthly_limit || subscription?.usage_limit) return 'monthly allocation';
    return 'token balance';
  })();

  return (
    <div className="candor-page">
      <StatusCards
        subscription={subscription}
        getUsagePercentage={getUsagePercentage}
        getRemainingRequests={getRemainingRequests}
      />

      <section className="candor-panel">
        <div className="candor-panel-header">
          <h3 className="candor-panel-title">Usage this period</h3>
          <span className="candor-status-pill candor-status-pill--neutral">{statusLabel}</span>
        </div>
        <p className="candor-panel-meta">
          {planLabel}
          {freeLike ? ' · Community / free tier' : ''}
          {' · '}
          {tokenResetLabel(subscription)}
        </p>
        <div className="candor-progress-track" aria-hidden>
          <div className="candor-progress-fill" style={{ width: `${usagePct}%` }} />
        </div>
        <div className="candor-progress-labels">
          <span>
            {usagePct}% of {allocationLabel} used
          </span>
          <span>{Math.max(0, 100 - usagePct)}% remaining</span>
        </div>
      </section>

      <div className="mt-4">
        <PlanLimitsPanel subscription={subscription} />
      </div>
    </div>
  );
};

export default DashboardOverview;
